import React, { useRef } from 'react';
import { Modal, ModalProps, Platform, ScrollView } from 'react-native';
import styled from 'styled-components/native';

import { Feather } from '@expo/vector-icons';

import HtmlWebView from '../../components/HtmlWebView';
import IconButton from '../../components/IconButton';
import Colors from '../../constants/Colors';
import { H4 } from '../../components/Typography';
import { WebViewNavigation } from 'react-native-webview';

const StyledDimContainer = styled.View`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  padding: 30px;
`;

const StyledScrollView = styled.ScrollView.attrs(() => ({ flexGrow: 1 }))`
  /* margin: 10px 0 10px 0; */
`;

const StyledContainer = styled.View`
  margin-top: ${Platform.OS === 'android' ? '36px' : '76px'};
  width: 100%;
  height: 80%;
  border-radius: 32px;
  max-width: 1080px;
  background-color: white;
  border-radius: 32px;
  overflow: hidden;
`;

const StyledContentContainer = styled.View<{ contentPadding?: boolean }>`
  padding: ${p => (p.contentPadding ? '22px 37px 0 37px' : 0)};
`;

const StyledHeader = styled.View`
  flex-direction: row;
  background-color: #fff;
  align-items: center;
  padding: 12px 18px;
  margin-bottom: ${Platform.OS === 'android' ? 8 : 0}px;
`;

const StyledCloseIconButton = styled(IconButton)``;

const StyledTitleText = styled(H4)`
  color: ${Colors.primary};
  flex: 1 1 auto;
`;

const WebViewModal: React.FC<
  ModalProps & {
    title: string;
    html?: string;
    url?: string;
    height?: number;
    contentPadding?: boolean;
    incognito?: boolean;
    scrollOnFieldClicked?: boolean;
    onNavigationStateChange?: ((event: WebViewNavigation) => void) &
      ((event: WebViewNavigation) => void);
    onClose: () => void;
  }
> = ({
  title,
  html,
  url,
  contentPadding,
  incognito,
  height,
  scrollOnFieldClicked,
  onClose,
  onNavigationStateChange,
  ...props
}) => {
  const scrollViewRef = useRef<ScrollView>(null!);
  return (
    <Modal transparent {...props}>
      <StyledDimContainer>
        <StyledContainer>
          <StyledHeader>
            {!!title && (
              <StyledTitleText numberOfLines={1} ellipsizeMode='tail'>
                {title}
              </StyledTitleText>
            )}
            <StyledCloseIconButton onPress={() => onClose?.()}>
              <Feather name='x' size={30} color={Colors.primary} />
            </StyledCloseIconButton>
          </StyledHeader>
          <StyledScrollView overScrollMode='never' ref={scrollViewRef}>
            <StyledContentContainer contentPadding={contentPadding}>
              <HtmlWebView
                height={height}
                html={
                  url
                    ? undefined
                    : `<body style="margin: 0; background-color: transparent; padding: 0;"><div style="position:relative;" >${html}</div></body>`
                }
                incognito={incognito}
                onNavigationStateChange={onNavigationStateChange}
                url={url}
                {...(scrollOnFieldClicked
                  ? {
                      onFieldClicked(top) {
                        scrollViewRef.current?.scrollTo({
                          y: top - 50
                        });
                      }
                    }
                  : {})}
                onLoad={() => {
                  if (scrollViewRef) {
                    scrollViewRef.current?.scrollTo({
                      x: 0,
                      y: 0,
                      animated: false
                    });
                  }
                }}
              />
            </StyledContentContainer>
          </StyledScrollView>
        </StyledContainer>
      </StyledDimContainer>
    </Modal>
  );
};

export default WebViewModal;
